import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { SERVER_API_URL } from './../../app.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonHttpService {
  private baseUrl = SERVER_API_URL.concat('api/');

  private httpHeaders = new HttpHeaders({
    'Content-type': 'application/json'
  });
  private httpHeadersMultipart = new HttpHeaders({
    'content-type': 'multipart/form-data'
  });

  constructor(private http: HttpClient) {}

  get(apiUrl: string): Observable<HttpResponse<any>> {
    const url = this.baseUrl.concat(apiUrl);
    return this.http.get<any>(url, { observe: 'response' });
  }

  getWithParams(
    apiUrl: string,
    params: HttpParams
  ): Observable<HttpResponse<any>> {
    const url = this.baseUrl + apiUrl;
    return this.http.get<any>(url, { observe: 'response', params });
  }

  post(payload: object, apiUrl: string): Observable<HttpResponse<any>> {
    const url = this.baseUrl + apiUrl;
    return this.http.post<any>(url, payload, {
      headers: this.httpHeaders,
      observe: 'response'
    });
  }

  postAsMultipart(payload: object, apiUrl: string): Observable<HttpEvent<any>> {
    const url = this.baseUrl + apiUrl;
    return this.http.post<any>(url, payload, {
      observe: 'events',
      reportProgress: true
    });
  }

  download(payload: object, apiUrl: string): Observable<Blob> {
    const url = this.baseUrl + apiUrl;
    return this.http.post(url, payload, {
      headers: this.httpHeaders,
      responseType: 'blob'
    });
  }

  update(payload: object, apiUrl: string): Observable<HttpResponse<any>> {
    const url = this.baseUrl + apiUrl;
    return this.http.put<any>(url, payload, {
      headers: this.httpHeaders,
      observe: 'response'
    });
  }

  patch(payload: object, apiUrl: string): Observable<HttpResponse<any>> {
    const url = this.baseUrl + apiUrl;
    return this.http.patch<any>(url, payload, {
      headers: this.httpHeaders,
      observe: 'response'
    });
  }

  delete(apiUrl: string): Observable<HttpResponse<any>> {
    const url = this.baseUrl + apiUrl;
    return this.http.delete<any>(url, { observe: 'response' });
  }
}
